import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import GavelIcon from "@mui/icons-material/Gavel";
import StarIcon from "@mui/icons-material/Star";
import SchoolIcon from "@mui/icons-material/School";

import { colors } from "../../Theme/theme";

const signals = [
	{
		icon: <GavelIcon sx={{ fontSize: "1.4rem" }} />,
		label: "State Bar of New Mexico",
		sub: "Licensed & Active",
	},
	{
		icon: <StarIcon sx={{ fontSize: "1.4rem" }} />,
		label: "5.0 Google Rating",
		sub: "41 Client Reviews",
	},
	{
		icon: <SchoolIcon sx={{ fontSize: "1.4rem" }} />,
		label: "UNM School of Law",
		sub: "Juris Doctor",
	},
];

const CredibilityBar = () => {
	return (
		<Box
			sx={{
				backgroundColor: colors.primary.darker,
				borderBottom: `3px solid ${colors.accent.main}`,
				px: { xs: 2, md: 4 },
				py: { xs: 3.5, md: 3 },
			}}
		>
			<Box
				sx={{
					maxWidth: "1400px",
					mx: "auto",
					display: "flex",
					flexWrap: "wrap",
					alignItems: "center",
					justifyContent: "center",
					gap: { xs: 3, md: 0 },
				}}
			>
				{signals.map((signal, index) => (
					<React.Fragment key={signal.label}>
						<Box
							sx={{
								display: "flex",
								alignItems: "center",
								gap: 1.5,
								px: { xs: 2, md: 4 },
								color: "#fff",
							}}
						>
							<Box
								sx={{
									color: colors.accent.main,
									display: "flex",
									alignItems: "center",
									flexShrink: 0,
								}}
							>
								{signal.icon}
							</Box>
							<Box>
								<Typography
									sx={{
										fontSize: "0.95rem",
										fontWeight: 700,
										color: "#fff",
										lineHeight: 1.2,
										letterSpacing: "0.04em",
										fontFamily: "'Heebo', sans-serif",
									}}
								>
									{signal.label}
								</Typography>
								<Typography
									sx={{
										fontSize: "0.75rem",
										color: "rgba(255,255,255,0.55)",
										letterSpacing: "0.06em",
										textTransform: "uppercase",
										fontFamily: "'Heebo', sans-serif",
									}}
								>
									{signal.sub}
								</Typography>
							</Box>
						</Box>
						{index < signals.length - 1 && (
							<Divider
								orientation="vertical"
								flexItem
								sx={{
									borderColor: "rgba(255,255,255,0.12)",
									display: { xs: "none", md: "block" },
								}}
							/>
						)}
					</React.Fragment>
				))}
			</Box>
		</Box>
	);
};

export default CredibilityBar;
